import { render, staticRenderFns } from "./DirectionDetail.vue?vue&type=template&id=e81ce706&scoped=true"
import script from "./DirectionDetail.vue?vue&type=script&lang=js"
export * from "./DirectionDetail.vue?vue&type=script&lang=js"
import style0 from "./DirectionDetail.vue?vue&type=style&index=0&id=e81ce706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81ce706",
  null
  
)

export default component.exports